import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getChartValueColor } from '../../../../../../utils/chart';
import { BACKGROUND_COLORS } from '../../../../concept-response/components/concept-compare-section/charts/useConceptDatasets';
import getAverageAnnotations from '../../../../../../utils/getAverageAnnotations';
import createTooltipMarkup from './tooltip-markup/tooltipMarkup';

const useAudienceChartData = (selectedAudienceFilter, isFiltersApplied) => {
  const theme = useSelector((state) => state.global.theme);

  const backgroundData = useSelector((state) => state.resonance.backgroundData);
  const chartLabels = useMemo(() => backgroundData?.map((audience) => audience.subheader), [backgroundData]);

  const datasets = useMemo(() => {
    return [
      {
        label: selectedAudienceFilter.header,
        data: backgroundData?.map((audience) => (isFiltersApplied ? audience.clusteredTotal : audience.total)),
        backgroundColor: BACKGROUND_COLORS,
        borderWidth: 0,
        borderRadius: 8,
        pointStyle: false,
      },
    ];
  }, [selectedAudienceFilter, backgroundData, isFiltersApplied]);

  const averages = useMemo(() => {
    return backgroundData?.map((audience) => ({ value: audience.total }));
  }, [backgroundData]);

  const chartsConfig = useMemo(() => {
    return {
      options: {
        plugins: {
          legend: {
            display: true,
            labels: {
              color: getChartValueColor(theme),
              font: {
                size: 14,
              },
            },
          },
        },
      },
      tooltip: {
        createMarkup: (tooltipModel) => createTooltipMarkup({ tooltipModel, averages, isFiltersApplied }),
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: getChartValueColor(theme),
        font: {
          size: '12px',
          weight: 'bold',
          family: 'Inter',
        },
        formatter: function (value) {
          return value ? value + '%' : '';
        },
      },
      scales: {
        x: {
          ticks: {
            display: false,
          },
        },
      },

      annotations: isFiltersApplied ? getAverageAnnotations({ averages: averages }) : [],
    };
  }, [theme, isFiltersApplied, averages]);

  return {
    chartLabels,
    datasets,
    chartsConfig,
  };
};

export default useAudienceChartData;
